// extracted by mini-css-extract-plugin
export default {"videoContent":"youtube-embed_videoContent__wBx+h","video":"youtube-embed_video__-FURP"};